/* eslint-disable react/react-in-jsx-scope */
import { Icons, Typography } from '@jcm/design-system';
import { EnumNovidade } from '../../../ts/enums/NovidadesEnum';
import estilos from './index.module.scss';

export const iconeNotificacao = (tipo: EnumNovidade) => {
	switch (tipo) {
		case EnumNovidade.Bug:
			return (
				<>
					<Icons.EmergencyHome className={estilos.icone} style={{ color: 'red' }} />
					<Typography.Title className={estilos.titulo}>Inconsistência no sistema</Typography.Title>
				</>
			);
		case EnumNovidade.Sistema:
			return (
				<>
					<Icons.Info className={estilos.icone} style={{ color: '#fab35a' }} />
					<Typography.Title className={estilos.titulo}>Notificação</Typography.Title>
				</>
			);
		case EnumNovidade.Informativo:
			return (
				<>
					<Icons.Campaign className={estilos.icone} style={{ color: 'green' }} />
					<Typography.Title className={estilos.titulo}>Anúncio</Typography.Title>
				</>
			);
		default:
			return null;
	}
};
